/** @format */

import cloneDeep from 'lodash.clonedeep';
import findIndex from 'lodash.findindex';
import * as serviceInitTypes from './serviceInitTypes';
import {
  fetchEngagementList,
  fetchInitationTypeList,
  fetchServiceTypeList,
  fetchPassportCountryList,
  fetchRelationshipStatusList,
  fetchEmployeeTypeList,
  fetchCountryList,
  fetchServiceDetails,
  addNewEmployee,
  getSSIFiltersAPI, //AG
} from 'src/services/serviceinit.service.js';
import { checkRequiredFields, checkOrganizerCreated, deriveNewMenuAndProgress } from './serviceInitReselect';
import { manualInitiationMenu, batchInitiationMenu } from './serviceInitReducer';
//import { fetchShowOrganizer, persistShowOrganizer, createShowOrganizer, persistOrg } from 'src/services/cms.service.js';
import { fetchShowOrganizer, persistShowOrganizer, createShowOrganizer } from 'src/services/cms.service.js';
import { transformFormValues } from 'src/helpers';
import { SI_ADDINITIATION_VIEWTYPES, SI_INITIATION_TYPES, SI_MENU_PAGESTATES, CREATEORGANIZER_PAGESTATES } from 'src/constants/constants';

export const getEngagementList = () => {
  return async (dispatch, getState) => {
    dispatch(getEngagementSuccess(await fetchEngagementList()));
  };
};

export const getEngagementSuccess = data => ({
  type: serviceInitTypes.GET_ENGAGEMENT_SUCCESS,
  data: data.messages,
});

export const getInitationTypeList = () => {
  return async (dispatch, getState) => {
    dispatch(getInitationTypeSuccess(await fetchInitationTypeList()));
  };
};

export const getInitationTypeSuccess = data => ({
  type: serviceInitTypes.GET_INITIATIONTYPE_SUCCESS,
  data: data.messages,
});

export const getServiceTypeList = (year, engagement) => {
  return async (dispatch, getState) => {
    dispatch(getServiceTypeSuccess(await fetchServiceTypeList(year, engagement)));
  };
};

export const getServiceTypeSuccess = data => ({
  type: serviceInitTypes.GET_SERVICETYPE_SUCCESS,
  data: data.messages,
});

export const getPassportCountryList = () => {
  return async (dispatch, getState) => {
    dispatch(getPassportCountryListSuccess(await fetchPassportCountryList()));
  };
};

export const getPassportCountryListSuccess = data => ({
  type: serviceInitTypes.GET_PASSPORT_COUNTRYLIST_SUCCESS,
  data: data.messages,
});

export const getCountryList = (year, serviceType) => {
  return async (dispatch, getState) => {
    dispatch(getCountryListSuccess(await fetchCountryList(year, serviceType)));
  };
};

export const getCountryListSuccess = data => ({
  type: serviceInitTypes.GET_COUNTRYLIST_SUCCESS,
  data: data.messages,
});

export const getRelationshipStatusList = () => {
  return async (dispatch, getState) => {
    dispatch(getRelationshipStatusListSuccess(await fetchRelationshipStatusList()));
  };
};

export const getRelationshipStatusListSuccess = data => ({
  type: serviceInitTypes.GET_PASSPORT_RELATIONSHIPSTATUS_SUCCESS,
  data: data.messages,
});

export const getEmployeeTypeList = () => {
  return async (dispatch, getState) => {
    dispatch(getEmployeeTypeListSuccess(await fetchEmployeeTypeList()));
  };
};

export const getEmployeeTypeListSuccess = data => ({
  type: serviceInitTypes.GET_EMPLOYEETYPELIST_SUCCESS,
  data: data.messages,
});

export const createNewEmployeeSuccess = data => ({
  type: serviceInitTypes.CREATE_NEWEMPLOYEE_SUCCESS,
  data,
});

export const createNewEmployeeFailure = data => ({
  type: serviceInitTypes.CREATE_NEWEMPLOYEE_FAILURE,
  data,
});

export const createNewEmployee = (employeeData, cb = () => {}) => {
  return async (dispatch, getState) => {
    const { passportCountryList, addInitiation } = getState().serviceInit;

    const countryCode = passportCountryList.reduce((acc, next) => {
      if (next.countryName === employeeData.passportCountry) {
        acc = next.countryCode;
      }
      return acc;
    }, '');

    const result = await addNewEmployee(
      {
        languageId: 32,
        engagementId: addInitiation.engagement,
        ...employeeData,
        passportCountry: countryCode,
      },
      serviceInitTypes.CREATE_NEWEMPLOYEE_FAILURE,
    );

    if (result && result.messages) {
      dispatch(
        createNewEmployeeSuccess({
          employeeName: result.messages.name,
          employeeId: result.messages.employeeId,
        }),
      );
      cb();
    }
  };
};

export const setPersistOrganizer = (isDraft = true, shouldRefreshOrganizer = true, nextMenuPage, viewOffset = null, cb = () => {}) => {
  return async (dispatch, getState) => {
    let { addInitiation } = getState().serviceInit;

    let pageId = addInitiation.menu[addInitiation.currentMenuPage].pageId;

    // if user is a on static page there's nothing to derive
    if (addInitiation.viewType !== SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT) {
      const isOrganizerReady = checkOrganizerCreated(getState());

      if (!isOrganizerReady) {
        await dispatch(createOrganizer({}, true));

        // refresh state & set pageId to last page because we're going to be sending an
        // empty dataRequests in this scenario and the first page has user information filled
        addInitiation = getState().serviceInit.addInitiation;
        pageId = addInitiation.organizerInfo.lastPageId;
      } else {
        cb();
        return true;
      }
    }

    const { formValues, isFormComplete } = addInitiation.dynamicFormValues;
    const pageState = isFormComplete ? CREATEORGANIZER_PAGESTATES.COMPLETE : CREATEORGANIZER_PAGESTATES.CURRENT_NOT_COMPLETE;

    const orgOptions = {
      assigneeServicePlanGlobalId: addInitiation.organizerInfo.assigneeServicePlanGlobalId,
      organizerInstanceId: addInitiation.organizerInfo.organizerInstanceId,
      organizerTypeId: 168,
      yearTypeId: 14,
      pageId,
      pageSourceId: addInitiation.organizerInfo.sourceTableId, // seems odd to use sourceTableId?
      languageId: 1,
      isDrafted: isDraft,
      isSubmited: !isDraft,
      pagestate: pageState,
      ...transformFormValues(formValues),
    };

    if (shouldRefreshOrganizer) {
      dispatch(resetDynamicContent());
    }
    const result = await persistShowOrganizer(orgOptions);
    // const result = await persistOrg(orgOptions);

    if (result && result.success) {
      if (shouldRefreshOrganizer) {
        const { menus } = result.response;
        const { menu, progress } = deriveNewMenuAndProgress(menus, [])(getState());

        dispatch({ type: serviceInitTypes.UPDATE_MENU, menu, progress });

        if (nextMenuPage) dispatch(getShowOrganizer(nextMenuPage));
      }

      cb();
    }
  };
};

// could add option `skipMenu`
// then need to show the notification
export const createOrganizer = (options = {}, skipMenuRefresh = false) => {
  return async (dispatch, getState) => {
    const { addInitiation, passportCountryList } = getState().serviceInit;
    const { userInfo } = getState().login;

    let personId = userInfo.personId;

    if (addInitiation.initiationType === SI_INITIATION_TYPES.MANUAL_INITIATION) {
      if (addInitiation.employee && addInitiation.employee.employeeId) {
        personId = addInitiation.employee.employeeId;
      } else {
        const countryCode = passportCountryList.reduce((acc, next) => {
          if (next.countryName === addInitiation.employee.passportCountry) {
            acc = next.countryCode;
          }
          return acc;
        }, '');

        const addEmployeeResult = await addNewEmployee({
          languageId: 32,
          engagementId: addInitiation.engagement,
          ...addInitiation.employee,
          passportCountry: countryCode,
        });

        if (addEmployeeResult && addEmployeeResult.success === false) {
          dispatch(createNewEmployeeFailure(addEmployeeResult));
          return false;
        }

        dispatch(
          createNewEmployeeSuccess({
            employeeName: addEmployeeResult.messages.name,
            ...addEmployeeResult.messages,
          }),
        );
        personId = addEmployeeResult.messages.employeeId;
      }
    }

    const orgOptions = {
      languageId: 1,
      engagementId: addInitiation.engagement,
      scrubbingCode: '1234A',
      ssiType: addInitiation.initiationType,
      ssiPersonId: personId,
      year: 2017,
      listOfSSIService: [
        {
          countryCode: addInitiation.country,
          productTypeAb: addInitiation.serviceType,
        },
      ],
    };

    const result = await createShowOrganizer(orgOptions);

    if (result && result.success) {
      const { menus, ...response } = result.messages;
      const { menus: omitMenus, lookups, pageElements, ...organizerInfo } = response;

      const { menu, progress } = deriveNewMenuAndProgress(menus, [addInitiation.currentMenuPage])(getState());

      organizerInfo.lastPageId = menu[menu.length - 1].pageId;

      dispatch(
        createOrganizerSuccess({
          data: response,
          menu: skipMenuRefresh ? addInitiation.menu : menu,
          viewOrder: skipMenuRefresh
            ? addInitiation.menu
            : menu.map(item => item.viewType).concat(SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT),
          options: {
            ...options,
            progress: skipMenuRefresh ? addInitiation.progress : progress,
            organizerInfo,
          },
        }),
      );
    } else {
      //alert('error occured', result);
    }
  };
};

export const createOrganizerSuccess = ({ data, menu, viewOrder, options }) => ({
  type: serviceInitTypes.CREATE_ORGANIZER_SUCCESS,
  data,
  menu,
  viewOrder,
  options,
});

export const getShowOrganizer = nextMenuPage => {
  return async (dispatch, getState) => {
    const { addInitiation } = getState().serviceInit;
    const currentMenu = addInitiation.menu[nextMenuPage];

    if (currentMenu.viewType !== SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT) return;

    const orgOptions = {
      assigneeServicePlanGlobalId: addInitiation.organizerInfo.assigneeServicePlanGlobalId,
      organizerTypeId: 168,
      yearTypeId: 14,
      lockGOAccess: true,
      showWelcomePage: false,
      pageId: currentMenu.pageId,
      isReadOnly: false,
      languageId: 1,
    };
    const { messages } = await fetchShowOrganizer(orgOptions);
    const { menus, ...response } = messages;

    const { menu, progress } = deriveNewMenuAndProgress(menus)(getState());
    dispatch(getShowOrganizerSuccess({ data: response, menu, progress }));
  };
};

export const getShowOrganizerSuccess = ({ data, menu, progress }) => ({
  type: serviceInitTypes.GET_SISHOWORGANIZER_SUCCESS,
  data,
  menu,
  progress,
});

export const setInitiationValue = (field, data, markFormUpdated = true) => {
  return (dispatch, getState) => {
    const { addInitiation } = getState().serviceInit;
    const { menu } = addInitiation;

    menu[addInitiation.currentMenuPage].isFormUpdated = markFormUpdated;

    dispatch({
      type: serviceInitTypes.SET_ADDINITIATION_VALUE,
      field,
      data,
      menu,
    });
  };
};

export const resetInitiation = () => ({
  type: serviceInitTypes.RESET_INITIATION,
});

export const resetEmployee = () => {
  return (dispatch, getState) => {
    const { addInitiation } = getState().serviceInit;
    const { menu } = addInitiation;

    menu.isFormUpdated = false;
    dispatch({ type: serviceInitTypes.RESET_EMPLOYEE, menu });
  };
};

export const resetDynamicContent = (wipeMenu = false) => {
  return (dispatch, getState) => {
    const { addInitiation } = getState().serviceInit;
    const { menu } = addInitiation;

    const staticMenuSize =
      addInitiation.initiationType === SI_INITIATION_TYPES.BATCH_INITIATION ? batchInitiationMenu.length : manualInitiationMenu.length;
    const newMenu = wipeMenu ? addInitiation.menu.slice(0, staticMenuSize) : menu;

    dispatch({
      type: serviceInitTypes.RESET_DYNAMIC_CONTENT,
      menu: newMenu,
    });
  };
};

export const resetDynamicFormValues = () => ({
  type: serviceInitTypes.RESET_DYNAMIC_FORMVALUES,
});

export const changeInitationType = nextType => {
  return async (dispatch, getState) => {
    const { addInitiation } = getState().serviceInit;
    let nextMenu = cloneDeep(nextType === SI_INITIATION_TYPES.MANUAL_INITIATION ? manualInitiationMenu : batchInitiationMenu);

    const viewOrder = nextMenu.map(item => item.viewType).concat(SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT);
    nextMenu[addInitiation.currentMenuPage].isFormUpdated = true;

    if (nextType === SI_INITIATION_TYPES.BATCH_INITIATION) {
      dispatch({
        type: serviceInitTypes.SET_BATCH_INITIATION_LOADING,
        initiationType: nextType,
        viewOrder,
        batchOptions: { country: 'ALL', serviceType: 'SSI' },
      });

      dispatch({ type: serviceInitTypes.SET_NEXT_DISABLED });
      dispatch({ type: serviceInitTypes.SSI_SHOW_LOADING });
      await dispatch(createOrganizer());
      dispatch({ type: serviceInitTypes.SSI_HIDE_LOADING });
      dispatch({ type: serviceInitTypes.SET_NEXT_ENABLED });
    } else {
      dispatch({
        type: serviceInitTypes.SET_MANUAL_INITIATION,
        menu: nextMenu,
        viewOrder,
        initiationType: nextType,
      });
    }
  };
};

export const changePage = (direction = 'forward') => {
  return (dispatch, getState) => {
    const { serviceInit } = getState();
    const { viewType, menu, viewOrder, currentMenuPage } = serviceInit.addInitiation;
    let nextViewType = null;

    const viewIndex = viewOrder.indexOf(viewType);
    const viewOffset = direction === 'forward' ? 1 : -1;
    let nextMenuPage = currentMenuPage + viewOffset;

    if (nextMenuPage < 0) {
      return false;
    }

    if (viewIndex !== -1 && viewType !== SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT) {
      nextViewType = viewOrder[viewIndex + viewOffset];
    } else {
      if (!menu[nextMenuPage]) {
        return false;
      }

      nextViewType = menu[nextMenuPage].viewType;
    }

    dispatch(gotoPage(nextViewType, nextMenuPage, viewOffset));
  };
};

export const gotoPage = (nextViewType, menuPage, viewOffset = null) => {
  return (dispatch, getState) => {
    const { serviceInit } = getState();
    const { viewType, menu, currentMenuPage, viewOrder, isOrganizerCreated } = serviceInit.addInitiation;
    const currentMenu = menu[currentMenuPage];

    let dispatchObj = {
      type: serviceInitTypes.GET_SI_CHANGEPAGE,
      viewType: nextViewType,
      currentMenuPage: menuPage,
      menu,
      viewOrder,
    };

    if (viewType === SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT) {
      /*
       * When moving away from a Dynamic Content page (viewType: SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT)
       * a /PersistOrganizer API call needs to be sent to save data on the current page
       */

      const isNextPageStatic = menu[menuPage].viewType !== SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT ? true : false;
      const finalNextPage = !isNextPageStatic && viewOffset ? currentMenuPage + viewOffset : menuPage;
      dispatch(setPersistOrganizer(true, true, finalNextPage, viewOffset));
    } else {
      const isPageComplete = checkRequiredFields(getState());

      /*
       * If the organizer has already been created and a user is revisiting a static page that is marked complete
       * and updates the form (`isFormUpdated`) then that changes the questionnaire
       * and restarts the whole process by dispatching a createShowOrganizer() request
       */

      if (
        (viewType === SI_ADDINITIATION_VIEWTYPES.ADD_APPLICANT && currentMenu.isFormUpdated) ||
        (isOrganizerCreated && currentMenu.isFormUpdated && isPageComplete)
      ) {
        dispatch(createOrganizer({ viewType: nextViewType, currentMenuPage: menuPage }));
        return true;
      }

      const menuIndex = findIndex(dispatchObj.menu, { viewType });

      if (menuIndex !== -1) {
        dispatchObj.menu[menuIndex].pageState = isPageComplete ? SI_MENU_PAGESTATES.COMPLETE : SI_MENU_PAGESTATES.CURRENT_NOT_COMPLETE;
        dispatchObj.menu[menuIndex].isFormUpdated = false;
      }

      // when moving from static -> dynamic page either createShowOrganizer or getShowOrganizer() to populate dynamic content
      if (nextViewType === SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT) {
        dispatch(getShowOrganizer(menuPage));
      }
    }

    dispatch(dispatchObj);
  };
};

export const resumeInitiationSuccess = ({ data, menu, options }) => ({
  type: serviceInitTypes.RESUME_INITIATION_SUCCESS,
  data,
  menu,
  options,
});

export const resumeInitiation = (year = '', assigneeServicePlanGlobalId = '') => {
  return async (dispatch, getState) => {
    dispatch({ type: serviceInitTypes.SSI_SHOW_LOADING });

    const detailsResult = await fetchServiceDetails(year, assigneeServicePlanGlobalId);

    if (detailsResult && detailsResult.success) {
      const { employee, engagementId: engagement, countryCode: country, serviceType, ...initDetails } = detailsResult.messages;

      dispatch(changeInitationType(initDetails.initiationTypeId));

      const orgOptions = {
        ...initDetails,
        assigneeServicePlanGlobalId: assigneeServicePlanGlobalId,
        lockGOAccess: true,
        showWelcomePage: false,
        pageId: 0,
        isReadOnly: false,
        languageId: 1,
      };

      const { messages } = await fetchShowOrganizer(orgOptions);
      const { menus, ...response } = messages;

      /* mark all static menus as complete */
      const staticMenuSize =
        initDetails.initiationTypeId === SI_INITIATION_TYPES.BATCH_INITIATION ? batchInitiationMenu.length : manualInitiationMenu.length;
      const menusToMarkComplete = Array.from({ length: staticMenuSize }, (_, i) => i);

      const { menu, progress } = deriveNewMenuAndProgress(menus, menusToMarkComplete)(getState());

      /* load initial items */
      if (initDetails.initiationTypeId === SI_INITIATION_TYPES.MANUAL_INITIATION) {
        await Promise.all([
          dispatch(getEngagementList()),
          dispatch(getInitationTypeList()),
          dispatch(getCountryList(2017, detailsResult.messages.serviceType)),
          dispatch(getServiceTypeList(2017, [])),
        ]);
      }

      const viewOrder = menu.map(item => item.viewType).concat(SI_ADDINITIATION_VIEWTYPES.DYNAMIC_CONTENT);

      dispatch(
        resumeInitiationSuccess({
          data: response,
          menu,
          options: {
            progress,
            viewOrder,
            organizerInfo: {
              ...initDetails,
              assigneeServicePlanGlobalId,
              pageId: response.pageId,
              pageState: response.pageState,
              sourceTableId: response.sourceTableId,
              organizerInstanceId: assigneeServicePlanGlobalId,
            },
            employee: {
              engagement: employee.engagement,
              employeeId: employee.employeeId,
              employeeName: `${employee.firstName} ${employee.lastName}`,
              location: 'Atlanta, GA - United States',
              dateOfBirth: employee.dateOfBirth,
              email: employee.email,
            },
            engagement,
            country,
            serviceType,
            initiationType: initDetails.initiationTypeId,
            dynamicContent: {},
          },
        }),
      );
    }

    dispatch({ type: serviceInitTypes.SSI_HIDE_LOADING });
  };
};

// filters AG
export const getSSIFilters = () => {
  return async dispatch => {
    await getSSIFiltersAPI()
      .then(res => {
        if (res.success) dispatch(getSSIFiltersSuccess(res));
        else throw new Error(res.error.message);
      })
      .catch(err => {
        console.error(err);
      });
  };
};

export const getSSIFiltersSuccess = payload => ({
  type: serviceInitTypes.GET_FILTERS_SUCCESS,
  payload,
});

export const toggleModal = (status, anchorEl) => ({
  type: serviceInitTypes.SHOW_FILTER_MODAL,
  status,
  anchorEl,
});
